import { WhyChooseUsTypes } from '..';
import { tabletscreensize } from '../../../../../../utilities/constants';
import { useWindowDimensions } from '../../../../../../utilities/Dimensions';

export const getTextColor = (theme: WhyChooseUsTypes.TThemeModes) => {
  return theme === 'dark' ? 'white' : 'black';
};
export const getColorForBgImageVariant = (
  theme: WhyChooseUsTypes.TThemeModes,
  type: 'text' | 'icon'
) => {
  const { width } = useWindowDimensions();
  if (theme === 'dark') {
    if (width < tabletscreensize) {
      return 'white';
    } else {
      return type === 'text' ? 'black' : 'primary';
    }
  } else if (theme === 'light') {
    if (width < tabletscreensize) {
      return type === 'text' ? 'black' : 'primary';
    } else {
      return type === 'text' ? 'white' : 'primary';
    }
  }
};
export const selectSpanTextColor = (
  theme: WhyChooseUsTypes.TThemeModes,
  tileBackgroundImageToggle?: WhyChooseUsTypes.TBackgroundImageToggle
) => {
  const { width } = useWindowDimensions();
  if (theme === 'dark') {
    if (width < tabletscreensize) {
      return 'has-text-white whyChooseUsText';
    } else {
      return tileBackgroundImageToggle?.show
        ? 'has-text-white whyChooseUsText'
        : 'has-text-black whyChooseUsText';
    }
  } else {
    if (width < tabletscreensize) {
      return 'has-text-black whyChooseUsText';
    }
    return tileBackgroundImageToggle?.show
      ? 'has-text-white whyChooseUsText'
      : 'has-text-black whyChooseUsText';
  }
};

export const getIconsColor = (theme: WhyChooseUsTypes.TThemeModes) => {
  return theme === 'dark' ? 'secondary' : 'primary';
};
